import styled, { css, keyframes } from 'styled-components';
import * as Accordion from '@radix-ui/react-accordion';
import { colors, spacing, fonts } from 'ui/theme';
import { AccordionTypes } from './types';

const styling = {
  [AccordionTypes.Default]: css`
    background-color: ${colors.grey1};
  `,
  [AccordionTypes.Error]: css`
    background-color: ${colors.white};
    border: ${spacing.single} solid ${colors.grey15};
  `,
};

export const StyledTrigger = styled(Accordion.Trigger)`
  all: unset;
  display: flex;
  align-items: center;
  > [data-id='chevron'] {
    margin-left: auto;
    transition: transform 300ms cubic-bezier(0.87, 0, 0.13, 1);
  }
  &[data-state='open'] > [data-id='chevron'] {
    transform: rotate(90deg);
  }
`;

export const StyledAccordionRoot = styled(Accordion.Root)<{ $type: AccordionTypes }>`
  border-radius: ${spacing.half};
  padding: ${spacing.threeQuarter} ${spacing.base};
  font-family: ${fonts.sansSerif};
  ${({ $type }) => styling[$type]}
`;

export const StyledAccordionItem = styled(Accordion.Item)`
  display: flex;
  flex-direction: column;
`;

const slideDown = keyframes`
  from {
    height: 0;
    opacity: 0;
    margin-top: 0;
  }
  to {
    opacity: 1;
    height: calc(var(--radix-accordion-content-height));
    margin-top: ${spacing.base};
  }
`;

const slideUp = keyframes`
  from {
    opacity: 1;
    height: calc(var(--radix-accordion-content-height));
    margin-top: ${spacing.base};
  }
  to {
    opacity: 0;
    height: 0;
    margin-top: 0;
  }
`;

export const StyledAccordionContent = styled(Accordion.Content)`
  overflow: hidden;
  &[data-state='open'] {
    animation: ${slideDown} 300ms cubic-bezier(0.87, 0, 0.13, 1);
    opacity: 1;
    height: calc(var(--radix-accordion-content-height));
    margin-top: ${spacing.base};
  }
  &[data-state='closed'] {
    opacity: 0;
    height: 0;
    animation: ${slideUp} 300ms cubic-bezier(0.87, 0, 0.13, 1);
  }
`;
